export default {
    active: {
        id: 1
    },
    used: {
        id: 2
    },
    expired: {
        id: 3
    },
    invalidated: {
        id: 4
    },
    activated: {
        id: 5
    }
};
